export default __webpack_public_path__ + "static/media/Footpad's Gloves of the Fifth Stage.6ab361aa.jpg";